import ComponentHelper from '../../supers/ComponentHelper';
import AuthService from '../../services/AuthService';
import RESTService from '../../services/RESTService';
import queryString from 'query-string';
import InputField from '../../components/input-field/InputField';
import React from 'react';
import './signup.css';
import ValidationService from '../../services/ValidationService';
import RoutingService from '../../services/RoutingService';
import Spinner from '../../components/spinner/Spinner';

const connect = new RESTService();
const auth = new AuthService();
const RS = new RoutingService();
const VS = new ValidationService();

class Signup extends ComponentHelper {
	constructor(props) {
		super(props);
		// Get URL query string paramenters set by e-mail links.
		this.data = {
			queryData: queryString.parse(this.props.location.search),
			password: '',
			passwordConfirm: '',
			saving: false,
			errorMsg: null
		};
		if (this.props.history) {
			RS.setHistory(this.props.history);
		}
		this.autoBindAll(this);
	}

	// If the URL contains a sessionId and code parameters
	componentDidMount() {
		const { code } = queryString.parse(this.props.location.search);
		if (!code) {
			RS.goToRoute('/login');
		}
	}

	handleFormChange(evt) {
		this.observe(() => {
			this.data[evt.target.name] = evt.target.value;
		});
	}

	isValidPassword() {
		return VS.validatePassword(this.data.password);
	}

	onSave() {
		this.observe(() => {
			this.data.errorMsg = null;
			this.data.saving = true;
		});
		connect
			.signup({
				inviteId: this.data.queryData.code,
				password: this.data.password
			})
			.then(res => {
				auth.storeAccessToken(res.data.access_token);
				this.setData('saving', false);
			})
			.then(() => {
				if (auth.token) {
					this.props.history.push((this.props.location.state && this.props.location.state.from) || '/');
				}
			})
			.catch(err => {
				//TODO's use the new error object
				this.observe(() => {
					this.data.errorMsg = err.response.data;
					this.data.saving = false;
				});
			});
	}

	render() {
		const { password, passwordConfirm, saving, errorMsg } = this.data;

		return (
			<div className="signup-cmp animated fadeIn hbox vfit">
				<div className="img-cnt grow-2" />
				<div className="form-cnt grow-1 vbox vhcenter">
					<div className="logo" title="Mad Cloud">
						<i className="mdi mdi-cloud-outline" />
						<div className="letter">m</div>
					</div>
					{!saving && (
						<div className="vbox vcenter hcenter">
							<InputField
								handleChange={this.handleFormChange}
								name="password"
								label="New Password"
								type="password"
								required
								autoFocus={true}
								value={password}
								subText={'Password must be 8 characters max 15, contain:  1 number,  1 lowercase, 1 uppercase.'}
							/>
							<InputField
								handleChange={this.handleFormChange}
								name="passwordConfirm"
								label="Confirm Password"
								type="password"
								required
								value={passwordConfirm}
							/>
							<button
								className="btn primary"
								disabled={password.length === 0 || password !== passwordConfirm || !this.isValidPassword()}
								onClick={this.onSave}
							>
								Submit
							</button>
						</div>
					)}
					{errorMsg && <div className="error-msg">{errorMsg}</div>}
					{saving && <Spinner text="Setting things up..." />}
				</div>
			</div>
		);
	}
}

export default Signup;



// WEBPACK FOOTER //
// ./src/views/signup/Signup.js